import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';
import productsData from '../data/products.json';
import ServiceHighlight from '../Components/ServiceHighlight';
import ClientsCarousel from '../Components/ClientsCarousel';

function Home() {

  const products = productsData.products
    .filter(product => product.featured)
    .slice(0, 4);

  return (
    <div className="home-page">
      {/* Hero Section */}
   <section className="hero-section">

  {/* BACKGROUND VIDEO */}
  <video className="hero-video" autoPlay loop muted playsInline>
    <source src="/videos/bgese.mp4" type="video/mp4" />
  </video>

  {/* OVERLAY */}
  <div className="hero-overlay-graphic"></div>

  {/* CONTENT */}
  <div className="container hero-container">
    <div >
      <h1>
        Advanced Fire Protection & Engineering Solutions
      </h1>

      <p>
        <br></br>
        Protecting Lives, Securing Property, and Guaranteeing Business Continuity
        with State-of-the-Art Technology.
        <br></br>
      </p>

      <div className="hero-buttons">
        <Link to="/contact" className="btn btn-primary hero-btn-animate">
          Get a Free Consultation
        </Link>

        <Link to="/services" className="btn btn-outline hero-btn-animate">
          Explore Services
        </Link>
      </div>
    </div>
  </div>

</section>

      {/* Company Introduction */}
      <section className="section intro-section">
        <div className="container">
          <div className="intro-content text-center">
            <span className="badge-subtitle">Since 2016</span>
            <h2 className="section-title">Welcome to Esseltech Engineering</h2>
            <p className="intro-text">
              Established in July 2016, EsselTech Engineering is a premier Sri Lankan-based provider of integrated building services, specializing in MEP (Mechanical, Electrical, and Plumbing), ELV (Extra Low Voltage), and Fire Life Safety solutions. We serve a diverse range of sectors, including commercial, residential, hospitality, and industrial landscapes across Sri Lanka and the Maldives.
            </p>
          </div>
        </div>
      </section>

      {/* Services Overview */}
      <ServiceHighlight />

      {/* Why Choose Us */}
      <section className="section why-choose">
        <div className="container">
          <div className="wcu-layout">
            <div className="wcu-text">
              <h2 className="section-title text-left">Why Choose Esseltech?</h2>
              <p className="wcu-description">
                We believe that robust safety requires immaculate design. Trust a team that values precision engineering and compliance
                above all else. Here is what sets us apart in the industry:
              </p>
              <ul className="feature-list">
                <li>
                  <div className="check-icon">✓</div>
                  <div className="feature-content">
                    <strong>One-Stop Solution</strong>
                    <p>We offer a comprehensive vertical of services from initial design and consultation to supply, installation, testing, and commissioning.</p>
                  </div>
                </li>
                <li>
                  <div className="check-icon">✓</div>
                  <div className="feature-content">
                    <strong>Premium Partnerships</strong>
                    <p>We represent world-class brands such as <b>Honeywell (Morley-IAS, Notifier), System Group Italy, Tai Sin Singapore, and Eversafe Malaysia</b>, ensuring our clients receive only the highest quality components.</p>
                  </div>
                </li>
                <li>
                  <div className="check-icon">✓</div>
                  <div className="feature-content">
                    <strong>Uncompromising Quality</strong>
                    <p>All hardware and installations exceed global safety standards (NFPA compliant).</p>
                  </div>
                </li>
              </ul>
            </div>
            <div className="wcu-banner hover-float">
              <div className="wcu-stat-glass">
                <h2>10+</h2>
                <p>Years of Specialized<br />Industry Experience</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Clients Section */}
      <ClientsCarousel />

      {/* Featured Products */}
      <section className="section featured-products">
        <div className="container">
          <div className="section-header text-center">
            <h2 className="section-title">Premium Equipment Catalog</h2>
            <p className="section-subtitle">Authorized supplier of the globe's finest safety hardware</p>
          </div>
          <div className="products-grid">
            {products.map((product, index) => (
              <div key={index} className="product-showcase-card hover-lift">
                <div className="product-img-wrapper">
                  <img src={product.image} alt={product.name} className="product-image" />
                </div>
                <div className="product-info">
                  <h4>{product.name}</h4>
                  <p>{product.description}</p>
                  <Link to={`/products`} className="btn btn-outline product-btn">View Full Details</Link>
                </div>
              </div>
            ))}
          </div>
          <div className="text-center" style={{ marginTop: '40px' }}>
            <Link to="/products" className="btn btn-primary hero-btn-animate">Browse Entire Catalog</Link>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-dynamic-section">
        <div className="cta-overlay-pattern"></div>
        <div className="container cta-container relative z-10 text-center">
          <h2 className="cta-heading">Ready to Secure Your Operations?</h2>
          <p className="cta-subheading">Connect with our elite sourcing and engineering team for a personalized system audit.</p>
          <Link to="/contact" className="btn btn-primary cta-action-btn">Schedule Consultation</Link>
        </div>
      </section>

      {/* Contact Preview */}
      <section className="section contact-preview">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-info-card text-center hover-lift">
              <div className="contact-icon large-icon">📞</div>
              <h3>Call Us</h3>
              <p>General inquiries and emergency dispatch</p>
              <span className="contact-highlight" style={{fontSize: '0.9rem', lineHeight: '1.5', display: 'block'}}>+94 77 655 6000 (Hot Line)<br/>+94 71 655 6000 (Whatsapp Only)<br/>+94 113 495 900</span>
            </div>
            <div className="contact-info-card text-center hover-lift">
              <div className="contact-icon large-icon">✉️</div>
              <h3>Email Us</h3>
              <p>Documentation, quotes, and technical support</p>
              <span className="contact-highlight">info@esseltech.lk</span>
            </div>
            <div className="contact-info-card text-center hover-lift">
              <div className="contact-icon large-icon">📍</div>
              <h3>Head Office</h3>
              <p>Visit our corporate office</p>
              <span className="contact-highlight" style={{fontSize: '0.9rem', lineHeight: '1.5', display: 'block'}}>157 A 1/1 ,<br/>Dharmapala Mawatha ,<br/>Colombo 07 , 00700,<br/>Sri Lanka</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;